<div class="chart-component">
    <div class="legend">
        <div class="legend-item" *ngFor="let legend of data.legend">
            <span class="legend-color" [ngStyle]="{backgroundColor: legend.color}">
            </span>
            <span class="legend-text" [innerHTML]="legend.name + ' ' + legend.value">
            </span>
        </div>
    </div>
    <svg class="chart"></svg>
</div>

